export const SIGN_IN_USER = 'SIGN_IN_USER';
export const SIGN_OUT_USER = 'SIGN_OUT_USER';
export const SET_SUBSCRIBER = 'SET_SUBSCRIBER';
export const SET_STRIPE_SUBSCRIPTIONS = 'SET_STRIPE_SUBSCRIPTIONS';
export const SET_SHOW_ = 'SET_STRIPE_SUBSCRIPTIONS';
export const SET_JUST_CREATED_ANONYMOUS_ACCOUNT = 'SET_JUST_CREATED_ANONYMOUS_ACCOUNT';
export const SET_LOADED_REMOTE_CONFIG = 'SET_LOADED_REMOTE_CONFIG';

